import React, { useEffect, useState } from "react";
import { Input, Button } from "antd";
import { Col, Row, Form, Modal } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { Auth } from "../../../config/aws-exports";
import { useLocation } from "react-router-dom";
import { updateTeamMembers } from "../../../redux/actions";
import "./Activate.css";
import history from "../../../routes/history";
import terms_services from '../../Auth/components/TermsOfServices.js';
import { LoadingOutlined } from "@ant-design/icons";
import TopAlert from "../../../components/TopNotification/TopAlert";

function Activate(props) {
  const location = useLocation();
  const dispatch = useDispatch();

  const [Dimensions, setDimensions] = useState(getWindowDimensions());


  const success = useSelector(
    (state) => state.updateTeamMembersReducer.response
  );
  const loading = useSelector(
    (state) => state.updateTeamMembersReducer.loading
  );
  const [fullNameauth, setFullNameauth] = useState("");
  const [jobTitleauth, setJobTitleauth] = useState("");
  const [Emailauth, setEmailauth] = useState("");
  const [companyNameauth, setCompanyNameauth] = useState("");

  const [new_Password, setNewPassword] = useState("");
  const [greenCheckNewPassword, setGreenCheckNewPassword] = useState(false);
  const [showCheckNewPassword, setShowCheckNewPassword] = useState(false);
  const [passwordAuth, setPasswordAuth] = useState(false);
  const [userExistanceCheck, setUserExistanceCheck] = useState(false);

  const [FullName, setFullName] = useState("");
  const [Email, setEmail] = useState("");
  const [JobTitle, setJobTitle] = useState("");
  const [Loading, setLoading] = useState(false);
  const [activateHeader, setActivateHeader] = useState(false)
  const [companyName, setCompanyName] = useState("");

  useEffect(() => {
    setFullName(Dimensions.width < 769 ? props.Full_Name : location.state.Name);
    setEmail(Dimensions.width < 769 ? props.Email : location.state.Email);
    setJobTitle(
      Dimensions.width < 769 ? props.Job_Title : location.state.JobTitle
    );
    setCompanyName(
      Dimensions.width < 769 ? props.CompanyName : location.state.CompanyName
    );
  }, [location, props]);

  useEffect(() => {
    if (!loading) {
      setTimeout(() => {
        setLoading(loading);
      }, 2000);
    } else {
      setLoading(loading);
    }
  }, [loading]);






  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }




  useEffect(() => {
    function handleResize() {
      setDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const validateNewPassword = (e) => {
    setNewPassword(e.target.value);
    const v2 = /^\S{8,}$/;
    const valid = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}$/;

    if (new_Password.length > 0) {
      setShowCheckNewPassword(true);
      // setPasswordAuth("Please enter valid password");
    }
    if (valid.test(new_Password) && v2.test(new_Password)) {
      setGreenCheckNewPassword(true);
      // setPasswordAuth("");
    } else {
      setGreenCheckNewPassword(false);
    }
  };

  const SubmitDetails = () => {

    var error_;


    if (FullName === "") {
      error_ = true;
      setFullNameauth("Please add full name");
    } else {
      // const pattern = /^[a-zA-Z]{2,40}( [a-zA-Z]{2,40})+$/;

      // if (pattern.test(FullName)) {
      setFullNameauth("");

      error_ = false;
      // } else {
      //   setFullNameauth(
      //     "You must enter your first name (not just your initial) and last name separated by a space"
      //   );
      //   error_ = true;
      // }
    }
    if (Email === "") {
      setEmailauth("Please add email address");

      error_ = true;
    } else {
      const valid = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
      if (valid.test(Email)) {
        setEmailauth("");

        error_ = false;
      }



      else {
        setEmailauth("Please enter a proper email address");
        error_ = true;
      }
    }

    if (companyName === "") {
      setCompanyNameauth("Please add company name");

      error_ = true;
    } else {
      setCompanyNameauth("");

      error_ = false;
    }
    if (JobTitle === "") {
      setJobTitleauth("Please add job title");

      error_ = true;
    } else {
      setJobTitleauth("");

      error_ = false;
    }
    if (new_Password === "") {
      setPasswordAuth("Please add password");

      error_ = true;
    }

    if (new_Password != "") {
      const passwordValidation1 = /^\S{8,}$/;
      const passwordValidation2 = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}$/;

      if (
        (passwordValidation1?.test(new_Password)) &&
        (passwordValidation2?.test(new_Password))
      ) {
        setPasswordAuth("");
        error_ = false;

      }
      else {
        setPasswordAuth("Please enter a valid password");
        error_ = true;
      }
    }


    if (error_) {
      return;
    } else {
      setLoading(true);
      Auth.signUp({
        username: Email,
        password: new_Password,
        attributes: {
          // name: FullName,
          email: Email,
          'custom:account_name': FullName,
        },
      })

        .then((data) => {


          setActivateHeader(true)
          // setTimeout(() => {
          dispatch(
            updateTeamMembers(
              Dimensions.width > 768 ? location?.state.Id : props.invitationId,

              {
                FullName: FullName,
                EmailAddress: data.user.username,
                JobTitle,
              }
            )
          );
          Dimensions.width > 768 &&
            setTimeout(() => {
              if (success) {
                history.push(`/myteams`);
              }
            }, 5000);
          Dimensions.width < 769 && props.setShowModal(false);
          // }, 2000);
        })
        .catch((data) => {

          setUserExistanceCheck(true);
          setLoading(false);
        });
    }
  };

  useEffect(() => {
    const namePattern = /^[a-zA-Z]{2,40}( [a-zA-Z]{2,40})+$/;
    const emailPattern = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    const passwordValidation1 = /^\S{8,}$/;
    const passwordValidation2 = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}$/;
    if (FullName != "") {
      setFullNameauth("");
    }
    if (Email != "" && emailPattern.test(Email)) {
      setEmailauth("");
    }
    if (companyName != "") {
      setCompanyNameauth("");
    }
    if (JobTitle != "") {
      setJobTitleauth("");
    }
    if (new_Password != "") {
      setPasswordAuth("");
    }
    if (
      new_Password != "" &&
      passwordValidation1?.test(new_Password) &&
      passwordValidation2.test(new_Password)
    ) {
      setPasswordAuth("");
      setShowCheckNewPassword(true);
      setGreenCheckNewPassword(true);
    }


  }, [FullName, Email, companyName, JobTitle, new_Password]);
  return (


    <div className="Activate-primary-container">






      {activateHeader &&
        <>
          <TopAlert
            display={"block"}
            title={"Team member activated successfully"}
            type="success"
          />

        </>
      }


      {userExistanceCheck ? (
        <TopAlert
          display={"flex"}
          title={"An account with the given email already exists"}
          type="error"
        />
      ) : null}
      <div className="Activate-Container" >
        <div className="Activate-sec-container">
          {Dimensions.width > 768 && (
            <div className="Activate-Title" style={{ fontWeight: "bolder" }}>Activate</div>
          )}
          <Col style={{ marginTop: Dimensions.width < 768 ? "10px" : "0px" }}  >
            <Row>
              {Dimensions.width < 768 ? (
                <>
                  <div className="sub-title">Full name</div>
                  <div className="per-asterik"> *</div>
                </>
              ) : (
                <div className="sub-title" >
                  Full name{" "}
                  <span className="text-style-1" style={{ color: "#db2828" }}>
                    *
                  </span>
                </div>
              )}
            </Row>
            <Input
              disabled={true}
              type={"input"}
              className="team-per-inputfields"
              value={FullName}
              onChange={(e) => setFullName(e.target.value)}
              placeHolder="Add your full name here..."
            />
            {fullNameauth ? (
              <div className="team-perDetailErr">{fullNameauth}</div>
            ) : null}

            <Row>
              {Dimensions.width < 768 ? (
                <>
                  <div className="sub-title">Work email</div>
                  <div className="per-asterik"> *</div>
                </>
              ) : (
                <div className="sub-title">
                  Work email{" "}
                  <span className="text-style-1" style={{ color: "#db2828" }}>
                    *
                  </span>
                </div>
              )}
            </Row>
            <Input
              disabled={true}
              type={"email"}
              className="team-per-inputfields"
              value={Email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Add your email address..."
            />
            {Emailauth ? (
              <p className="team-perDetailErr">{Emailauth}</p>
            ) : null}

            <Row>
              {Dimensions.width < 768 ? (
                <>
                  <div className="sub-title">Company name</div>
                  <div className="per-asterik"> *</div>
                </>
              ) : (
                <div className="sub-title">
                  Company name{" "}
                  <span className="text-style-1" style={{ color: "#db2828" }}>
                    *
                  </span>
                </div>
              )}
            </Row>
            <Input
              disabled={true}
              type={"input"}
              className="team-per-inputfields"
              value={companyName}
              onChange={(e) => setCompanyName(e.target.value)}
              placeholder="Add your company name"
            />
            {companyNameauth ? (
              <p className="team-perDetailErr">{companyNameauth}</p>
            ) : null}
            <Row>
              {Dimensions.width < 768 ? (
                <>
                  <div className="sub-title">Job title</div>
                  <div className="per-asterik"> *</div>
                </>
              ) : (
                <div className="sub-title">
                  Job title{" "}
                  <span className="text-style-1" style={{ color: "#db2828" }}>
                    *
                  </span>
                </div>
              )}
            </Row>
            <Input
              disabled={true}
              type={"input"}
              className="team-per-inputfields"
              value={JobTitle}
              onChange={(e) => setJobTitle(e.target.value)}
              placeholder="Add your gig title ..."
            />
            {jobTitleauth ? (
              <p className="team-perDetailErr">{jobTitleauth}</p>
            ) : null}

            <Row>
              {Dimensions.width < 768 ? (
                <>
                  <div className="sub-title">Password</div>
                  <div className="per-asterik"> *</div>
                </>
              ) : (
                <div className="sub-title">
                  Password{" "}
                  <span className="text-style-1" style={{ color: "#db2828" }}>
                    *
                  </span>
                </div>
              )}
            </Row>
            <Form
              name="Password"
              className="team-login-form-activate"
              initialValues={{
                remember: false,
              }}
            >
              <div className="team-activate-password">
                <Form.Item
                  name="new_password"
                  rules={[
                    {
                      pattern: /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}$/,
                    },
                    {
                      required: true,
                    },
                  ]}
                  help={false}
                  extra={
                    <>
                      <div>
                        {passwordAuth ? (
                          <p className="team-perDetailErr">{passwordAuth}</p>
                        ) : null}
                      </div>
                      <div
                        className={`team-password-teams ${greenCheckNewPassword
                            ? `${showCheckNewPassword ? "team-validPrompt" : null
                            }`
                            : `${showCheckNewPassword
                              ? "team-notValidPrompt"
                              : null
                            }`
                          }`}
                      >
                        Password must contain at least 8 characters. Combine numbers, upper and lowercase letters.
                      </div>
                    </>
                  }
                >
                  <Input.Password
                    onChange={validateNewPassword}
                    placeholder="Add password here..."
                    className={`team-passwordBox-teams ${greenCheckNewPassword
                        ? "team-validInputCSS"
                        : `${showCheckNewPassword ? "team-notValidInput" : null
                        }`
                      }`}
                    iconRender={(visible) =>
                      visible ? (
                        <span
                          style={{
                            fontWeight: '500',
                            fontSize: '12px',
                            fontStretch: "normal",
                            fontStyle: "normal",
                            lineHeight: "normal",
                            letterSpacing: "normal",
                            textAlign: "right",
                            color: "#4054b2",
                          }}
                        >
                          Hide
                        </span>
                      ) : (
                        <span
                          style={{
                            fontWeight: '500',
                            fontSize: '12px',
                            fontStretch: "normal",
                            fontStyle: "normal",
                            lineHeight: "normal",
                            letterSpacing: "normal",
                            textAlign: "right",
                            color: "#4054b2",
                          }}
                        >
                          Show
                        </span>
                      )
                    }
                  />
                </Form.Item>
              </div>
            </Form>

            {Dimensions.width > 768 && <hr color="#e4e4e4" />}

            <div style={{ display: "flex", flexDirection: "row-reverse" }}>
              <Button
                style={{
                  marginTop: Dimensions.width > 768 ? null : '-0.1rem',
                  marginBottom: Dimensions.width > 768 ? null : '7px'
                }}
                className="team-button-add"
                onClick={() => SubmitDetails()}
                block={true}
              >
                {Dimensions.width > 768 ? (
                  Loading ? (
                    <LoadingOutlined />
                  ) : (
                    "Signup"
                  )
                ) : Loading ? (
                  <LoadingOutlined />
                ) : (
                  "Submit"
                )}
              </Button>
            </div>
          </Col>


          {Dimensions.width < 769 && (
            <div className="team-terms">
              By joining, I agree to SkillGigs{" "}
              <a style={{ color: "#1e1e1e", cursor: 'pointer' }} href="/terms">
                <u>Terms of Services</u>
              </a>

            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Activate;
